import { createContext } from 'react';

export const TextToSpeechValuesContext = createContext({});

export default TextToSpeechValuesContext;
